import { DOSAGE_FORMS, type DosageForm } from '../components/DosageFormDropdown';

export interface DosageFormMatchResult {
  dosageForm: DosageForm;
  drugNameOnly: string;
  confidence: number;
}

export function extractDosageFormFromInput(input: string): DosageFormMatchResult | null {
  if (!input || input.trim().length < 2) return null;

  const trimmed = input.trim();

  const sortedForms = [...DOSAGE_FORMS].sort((a, b) => {
    const aLen = a.name.length + a.aliases.reduce((s, al) => s + al.length, 0);
    const bLen = b.name.length + b.aliases.reduce((s, al) => s + al.length, 0);
    return bLen - aLen;
  });

  let bestMatch: DosageFormMatchResult | null = null;

  for (const form of sortedForms) {
    const allKeywords = [form.name, ...form.aliases];

    for (const keyword of allKeywords) {
      if (!keyword || keyword.length < 1) continue;

      const index = trimmed.indexOf(keyword);
      if (index === -1) continue;

      const drugNameOnly = (trimmed.slice(0, index) + trimmed.slice(index + keyword.length)).trim();

      const confidence = calculateMatchConfidence(trimmed, keyword, form, index);

      if (!bestMatch || confidence > bestMatch.confidence) {
        bestMatch = {
          dosageForm: form,
          drugNameOnly,
          confidence
        };
      }
    }
  }

  if (bestMatch && bestMatch.confidence >= 0.5) {
    return bestMatch;
  }

  return null;
}

function calculateMatchConfidence(
  input: string,
  matchedKeyword: string,
  form: DosageForm,
  matchIndex: number
): number {
  let confidence = 0.6;

  if (form.name === matchedKeyword) {
    confidence += 0.2;
  }

  if (matchIndex > 0) {
    confidence += 0.1;
  }

  if (matchIndex === input.length - matchedKeyword.length) {
    confidence += 0.1;
  }

  return Math.min(confidence, 1.0);
}
